import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
    EmailIconSvg,
    GoogleSvg,
    PasswordHideIcon,
    PasswordLockSvg,
    PasswordShowIcon,
    ProfileIconSvg,
} from "../assets/svg/SvgComponent";
import { API_URL, getHeaders, GOOGLE_API_KEY } from "../helper/commonApi";
import { useBranding } from "../context/BrandingContext";
import toast from "react-hot-toast";

const CreateAccountComponent = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [fullName, setFullName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [fullNameError, setFullNameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmError, setConfirmError] = useState("");
    const [generalError, setGeneralError] = useState("");
    // const [suggestedPassword, setSuggestedPassword] = useState();
    // const googleButtonRef = useRef(null);

    const { colors, portalID } = useBranding();

    // const validateEmail = (value) => {
    //     setGeneralError("");
    //     if (!value) return "Email is required";
    //     if (!/\S+@\S+\.\S+/.test(value)) return "Enter a valid email";
    //     return "";
    // };
    const validateEmail = (value) => {
        setGeneralError("");

        if (!value) return "Email is required";

        const email = value.trim();

        // Basic required structure
        const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!basicRegex.test(email)) return "Enter a valid email";

        const [local, domain] = email.split("@");

        //  Forbidden characters at start of local part
        const forbiddenStart = ['.', '-', '=', '+', '/', '*', '_'];
        if (forbiddenStart.includes(local[0])) {
            return "Enter a valid email";
        }

        //  Local cannot end with dot
        if (local.endsWith(".")) return "Enter a valid email";

        //  No consecutive dots anywhere
        if (email.includes("..")) return "Enter a valid email";

        // Split domain into segments: domain.com → ["domain", "com"]
        const domainParts = domain.split(".");

        //  Each domain segment must be valid
        for (const part of domainParts) {
            // Cannot start/end with hyphen
            if (part.startsWith("-") || part.endsWith("-")) {
                return "Enter a valid email";
            }
            // Cannot be empty (prevents domain..com)
            if (!part.trim()) {
                return "Enter a valid email";
            }
        }

        return "";
    };



    const validateFullName = (value) => {
        setGeneralError("");
        if (!value) return "Name is required";
        return "";
    };

    const validatePassword = (value) => {
        setGeneralError("");
        if (!value) return "Password is required";

        const minLength = /.{8,}/;
        const hasUpper = /[A-Z]/;
        const hasLower = /[a-z]/;
        const hasNumber = /\d/;
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/;

        if (!minLength.test(value)) return "Must be at least 8 characters";
        if (!hasUpper.test(value)) return "Must include at least one uppercase letter";
        if (!hasLower.test(value)) return "Must include at least one lowercase letter";
        if (!hasNumber.test(value)) return "Must include at least one number";
        if (!hasSpecial.test(value)) return "Must include at least one special character";

        return "";
    };

    // const generateStrongPassword = () => {
    //     const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    //     const lower = "abcdefghijklmnopqrstuvwxyz";
    //     const numbers = "0123456789";
    //     const symbols = "!@#$%^&*()_+[]{}|;:,.<>?";
    //     const all = upper + lower + numbers + symbols;

    //     let password = "";
    //     password += upper[Math.floor(Math.random() * upper.length)];
    //     password += lower[Math.floor(Math.random() * lower.length)];
    //     password += numbers[Math.floor(Math.random() * numbers.length)];
    //     password += symbols[Math.floor(Math.random() * symbols.length)];

    //     for (let i = 4; i < 10; i++) {
    //         password += all[Math.floor(Math.random() * all.length)];
    //     }

    //     return password
    //         .split("")
    //         .sort(() => 0.5 - Math.random())
    //         .join("");
    // };

    // useEffect(() => {
    //     let userId = localStorage.getItem('_register_GRE_LOGIN_userId');
    //     setSuggestedPassword(generateStrongPassword())
    //     if (userId) {
    //         navigate('/dashboard')
    //     }

    //     const script = document.createElement("script");
    //     script.src = "https://accounts.google.com/gsi/client";
    //     script.async = true;
    //     script.defer = true;
    //     script.onload = () => {
    //         if (window.google) {
    //             window.google.accounts.id.initialize({
    //                 client_id: GOOGLE_API_KEY,
    //                 callback: handleCredentialResponse,
    //                 ux_mode: "popup",
    //             });

    //             googleButtonRef.current = createFakeGoogleWrapper();
    //         }
    //     };
    //     document.body.appendChild(script);

    // }, [])

    useEffect(() => {
        const userId = localStorage.getItem("_register_GRE_LOGIN_userId");
        if (userId) {
            navigate('/dashboard')
        }

        // Load Google script
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        script.onload = () => {
            if (window.google) {
                // Pre-initialize client so it's ready for handleGoogleLogin
                window.googleClient = window.google.accounts.oauth2.initTokenClient({
                    client_id: GOOGLE_API_KEY,
                    scope: "email profile openid",
                    callback: handleGoogleResponse,
                });
            }
        };

        return () => {
            document.body.removeChild(script); // cleanup script on unmount
        };
    }, []);

    const handleGoogleResponse = async (response) => {
        try {
            setLoading(true);

            const res = await axios.post(
                `${API_URL}/google-login`,
                {
                    access_token: response.access_token,
                    portal_id: portalID,
                },
                { headers: getHeaders() }
            );

            if (res.data?.status) {
                const { user_id, full_name, jwt_token, email, is_new_user, token_expires_in } = res.data.data;

                localStorage.setItem("_register_GRE_LOGIN_userId", user_id);
                localStorage.setItem("_register_GRE_LOGIN_full_name", full_name);
                localStorage.setItem('_register_GRE_userEmail', email)
                localStorage.setItem("_register_GRE_LOGIN_JWT_TOKEN", jwt_token);

                if (is_new_user) {
                    navigate("/verify-mail"); // or welcome flow
                } else {
                    const tokenExpires = token_expires_in || 18000;
                    const expires = new Date(Date.now() + tokenExpires * 1000).toUTCString();
                    document.cookie = `_GRE_JWT_TOKEN=${jwt_token}; expires=${expires}; path=/; Secure; SameSite=Strict`;
                    navigate("/dashboard");
                }
                toast.success(res?.data?.message)
            } else {
                setGeneralError({ form: res?.data?.message || "Google login failed" });
            }
        } catch (err) {
            console.error("Google login error:", err);
            setGeneralError({ form: "Google login failed. Try again." });
        } finally {
            setLoading(false);
        }
    };

    // const parseJwt = (token) => {
    //     const base64Url = token.split(".")[1];
    //     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    //     const jsonPayload = decodeURIComponent(
    //         atob(base64)
    //             .split("")
    //             .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
    //             .join("")
    //     );
    //     return JSON.parse(jsonPayload);
    // };

    // const handleCredentialResponse = (response) => {
    //     const userData = parseJwt(response.credential);
    //     handleSubmit(userData, true)
    // };

    // const createFakeGoogleWrapper = () => {
    //     const wrapper = document.createElement("div");
    //     wrapper.style.display = "none";
    //     wrapper.classList.add("custom-google-button");
    //     document.body.appendChild(wrapper);

    //     window?.google?.accounts?.id?.renderButton(wrapper, {
    //         type: "icon",
    //         width: "200",
    //     });

    //     const button = wrapper.querySelector("div[role=button]");
    //     return () => {
    //         if (button) button.click();
    //     };
    // };

    const handleGoogleLogin = () => {
        // if (googleButtonRef.current) {
        //     googleButtonRef.current();
        // }

        if (window.googleClient) {
            window.googleClient.requestAccessToken(); // Trigger Google login popup
        } else {
            setGeneralError({ form: "Google client not initialized yet." });
        }
    };



    const validateConfirmPassword = (value, passwordValue) => {
        setGeneralError("");
        if (!value) return "Confirm your password";
        if (value !== passwordValue) return "Passwords do not match";
        return "";
    };

    const validateForm = () => {
        const emailErr = validateEmail(email);
        const fullNameErr = validateFullName(fullName);
        const passErr = validatePassword(password);
        const confirmErr = validateConfirmPassword(confirmPass, password);

        setEmailError(emailErr);
        setFullNameError(fullNameErr);
        setPasswordError(passErr);
        setConfirmError(confirmErr);

        if (emailErr || passErr || confirmErr) return false;

        setGeneralError("");
        return true;
    };

    const handleSubmit = async (userData, passWithoutValidation = false) => {
        if (!passWithoutValidation) {
            if (!validateForm()) return;
        }

        setLoading(true);
        const payload = {
            portal_id: portalID,
            email,
            password: password,
            // userType: "free",
            full_name: fullName,
        };

        let emailId = email;

        if (passWithoutValidation) {
            payload.password = userData?.email;
            payload.email = userData?.email;
            // payload.email = "gaurangdholariya2+test7@gmail.com";
            payload.full_name = `${userData?.given_name} ${userData?.family_name}`;
            payload.google = true;
            emailId = payload.email;
        }

        try {
            const res = await axios.post(`${API_URL}/register`, payload, {
                headers: getHeaders()
            });

            if (res?.status === 200 || res?.status === 201) {
                let userId = res?.data?.data?.user_id;
                if (userId) {
                    localStorage.setItem('_register_GRE_userEmail', emailId)
                    localStorage.setItem('_register_GRE_userId', userId)
                    localStorage.setItem('_register_GRE_full_name', payload.full_name)
                    localStorage.setItem('_register_GRE_is_register', true)

                    // toast.success("Registered successfully");
                    toast.success(res?.data?.message)
                    navigate("/verify-mail");
                } else {
                    setGeneralError(res?.data?.message || "Something went wrong");
                }

            } else {
                setGeneralError(res?.data?.message || "Something went wrong");
            }

        } catch (err) {
            if (err?.response && err?.response.data) {
                setGeneralError(err?.response?.data?.message || "Something went wrong");
            } else {
                setGeneralError("Server error");
            }
        } finally {
            setLoading(false); // Hide loader
        }
    };


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSubmit();
        }
    };

    return (
        <div style={{ margin: "20px" }} onKeyDown={handleKeyDown}>
            <div className="form-container" style={{ position: "relative" }}>
                <div className="create-account">
                    {/* <h1>Create Account</h1> */}
                    <h1>
                        Welcome to the OMC GRE Test App
                        <sup style={{ color: "red" }}>*</sup>
                    </h1>
                    <p>Sign up to start your GRE preparation journey</p>

                    <div className="form">
                        {/* Email */}
                        <div className="input-wrapper">
                            <div className={`input-group ${emailError ? "error" : ""}`}>
                                <EmailIconSvg />
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    placeholder="Enter your mail here"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setEmailError(validateEmail(e.target.value));
                                    }}
                                />
                            </div>
                            {emailError && <span className="error-text">{emailError}</span>}
                        </div>

                        <div className="input-wrapper">
                            <div className={`input-group ${fullNameError ? "error" : ""}`}>
                                <ProfileIconSvg />
                                <input
                                    id="fullName"
                                    name="fullName"
                                    type="text"
                                    placeholder="Enter your full name here"
                                    value={fullName}
                                    onChange={(e) => {
                                        setFullName(e.target.value);
                                        setFullNameError(validateFullName(e.target.value));
                                    }}
                                />
                            </div>
                            {fullNameError && <span className="error-text">{fullNameError}</span>}
                        </div>

                        {/* Password */}
                        <div className="input-wrapper">
                            <div className={`input-group ${passwordError ? "error" : ""}`}>
                                <PasswordLockSvg />
                                <input
                                    id="password"
                                    name="password"
                                    type={showPass ? "text" : "password"}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setPassword(val);
                                        setPasswordError(validatePassword(val));
                                        setConfirmError(validateConfirmPassword(confirmPass, val));
                                    }}
                                    autoComplete="off"
                                />
                                <div
                                    className="input-type-password-toggle"
                                    onClick={() => setShowPass(!showPass)}
                                >
                                    {showPass ? <PasswordShowIcon /> : <PasswordHideIcon />}
                                </div>
                            </div>
                            {passwordError && (
                                <span className="error-text">{passwordError}</span>
                            )}
                            {/*{!password && (
                                <div className="password-suggestion">
                                    <span>🔐 Use a strong password like: </span>
                                    <code onClick={() => {
                                        setPassword(suggestedPassword);
                                        setPasswordError(validatePassword(suggestedPassword));
                                        setConfirmError(validateConfirmPassword(confirmPass, suggestedPassword));
                                    }} style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}>
                                        {suggestedPassword}
                                    </code>
                                </div>
                            )}*/}

                        </div>

                        {/* Confirm Password */}
                        <div className="input-wrapper">
                            <div className={`input-group ${confirmError ? "error" : ""}`}>
                                <PasswordLockSvg />
                                <input
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    type={showConfirm ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    value={confirmPass}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setConfirmPass(val);
                                        setConfirmError(validateConfirmPassword(val, password));
                                    }}
                                    autoComplete="off"
                                />
                                <div
                                    className="input-type-password-toggle"
                                    onClick={() => setShowConfirm(!showConfirm)}
                                >
                                    {showConfirm ? <PasswordShowIcon /> : <PasswordHideIcon />}
                                </div>
                            </div>
                            {confirmError && (
                                <span className="error-text">{confirmError}</span>
                            )}
                        </div>

                        {generalError && <div className="verify-otp-error">{generalError}</div>}

                        {/* Submit */}
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="register-btn btn black"
                            style={{ backgroundColor: colors?.buttonBg }}
                        >
                            {loading ? (
                                <span className="create-account-loader-btn" />
                            ) : (
                                "Register"
                            )}
                        </button>


                        {/* Social */}
                        <div className="register-text">
                            <strong>Have an account? </strong> <span onClick={() => navigate("/")}>Login here</span>
                            {/* <strong>Register</strong> <span>with Others</span> */}
                        </div>
                    </div>

                    <div className="google-login" onClick={handleGoogleLogin}>
                        <GoogleSvg />
                        Login with <span>google</span>
                    </div>
                </div>
                <div style={{ color: "red", position: "absolute", bottom: "12px", right: "20px" }}>* beta release</div>
            </div>

        </div>
    );
};

export default CreateAccountComponent;
